import { render, staticRenderFns } from "./new-product.mobile.modal.vue?vue&type=template&id=fa613414&scoped=true"
import script from "./new-product.mobile.modal.vue?vue&type=script&lang=js"
export * from "./new-product.mobile.modal.vue?vue&type=script&lang=js"
import style0 from "./new-product.mobile.modal.vue?vue&type=style&index=0&id=fa613414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa613414",
  null
  
)

export default component.exports